import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CoreDialogService } from 'src/app/core/dialogs/core-dialog.service';
import { ViewsService } from 'src/app/core/view/views.service';
import { MailingDetailComponent } from 'src/app/mailing/mailing-detail/mailing-detail.component';
import { ViewComponent } from '../../../core/view/view.component';
import { OrganizationsService } from '../../organizations.service';
import { OrganizationsDetailGeneralComponent } from '../organizations-detail-general/organizations-detail-general.component';
import { ContactsService } from './contacts.service';
import { MailMarketingNotificationToStatsComponent } from 'src/app/mail-marketing/mail-marketing-notification-to-stats/mail-marketing-notification-to-stats.component';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { ComponentService } from '../../../core/view/component.service';
import { CampaignsContactsService } from 'src/app/campaigns/campaigns-contacts.service';
import { AddCampaignsToEntityComponent } from 'src/app/campaigns/add-campaigns-to-entity/add-campaigns-to-entity.component';
import { LoginService } from 'src/app/login/login.service';
import { MapsDetailComponent } from 'src/app/maps/maps-detail/maps-detail.component';
import { ViewComponentTableComponent } from 'src/app/core/view/component/table/view-component-table.component';
import { TasksService } from 'src/app/tasks/tasks.service';
import { MeetingsService } from '../organizations-meetings-detail/meetings.service';
import { TransactionsService } from 'src/app/transactions/transactions.service';

@Component({
  selector: 'app-organizations-contacts-detail',
  templateUrl: './organizations-contacts-detail.component.html',
  styleUrls: ['./organizations-contacts-detail.component.scss']
})
export class OrganizationsContactsDetailComponent implements OnInit {
  public contact: any = {};
  public organization: any = {};
  public last_organization_id;
  public previousUrl;
  public view_map_button: boolean;
  //Cambios componente tasks
  public tasksFilters: any = {
    is_finished: false,
    _sortBy: "is_finished",
  };
  public dialogRef: DynamicDialogRef = null;

  @ViewChild("view") public view: ViewComponent;
  constructor(
    private route: ActivatedRoute,
    private organizationsService: OrganizationsService,
    private campaignContactsService: CampaignsContactsService,
    private messageService: MessageService,
    private contactService: ContactsService,
    //private config: DynamicDialogConfig,
    //private dynamicDialogRef: DynamicDialogRef,
    private coreDialogService: CoreDialogService,
    private dialogService: DialogService,
    private router: Router,
    private viewsService: ViewsService,
    private _location: Location,
    private translateService: TranslateService,
    public componentService: ComponentService,
    public loginService: LoginService,
    public tasksService: TasksService,
    public meetingsService: MeetingsService,
    public transactionsService: TransactionsService
  ) { }

  ngOnInit(): void {
    this.view_map_button = this.loginService.hasPermission("VIEW_MAP_BUTTON");

    this.route.params.subscribe(params => {
      this.loadData(params["id"]);
    });
    this.route.queryParams.subscribe(params => {
      this.previousUrl = params['returnUrl'];
    });
  }
  loadData(id: number) {
    if (id != 0) {
      this.contactService.get(id).subscribe({
        next: (data: any) => {
          this.contact = data;
          this.last_organization_id = this.contact.organization_id;
          //this.view.setModel(this.contact);
          this.refreshAll();
        },
        error: (error: any) => {
          this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
        }
      });
    } else {
      this.route.params.subscribe(params => {
        this.contact.organization_id = parseInt(params["organizationId"]);
      });
      //this.contact.organization_id = this.config.data.id;
    }
  }
  loadDataOrganization(id: number) {
    this.organizationsService.get(id).subscribe({
      next: (data: any) => {
        this.organization = data;
      },
      error: (error: any) => {
        this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
      }
    })
  }
  cancel() {
    this._location.back();
    //this.dynamicDialogRef.close();
  }
  save(event: any) {
    if (!event.valid) {
      this.messageService.add({
        closable: false, severity: "error", detail: this.translateService.instant("component.contacts.detail.form_incomplete")
      });
      return;
    }
    if (this.contact.email != null) this.contact.email = this.contact.email.trim();
    if (this.contact.email != null && this.contact.email.length > 0 && !this.validateEmail(this.contact.email)) {
      this.messageService.add({
        closable: false, severity: "error", detail: this.translateService.instant("component.contacts.detail.invalid_mail")
      });
      return;
    }

    if (typeof this.contact.id === "undefined") {
      this.contactService.add(this.contact).subscribe({
        next: (data: any) => {
          this.messageService.add({
            closable: false, severity: 'success', summary: this.translateService.instant("component.contacts.detail.add_contact_correct")
          });
          //this.dynamicDialogRef.close(data);
          if (this.previousUrl != null && this.previousUrl != "") {
            this.router.navigate([this.previousUrl]);
          } else {
            this._location.back();
          }
        },
        error: (error: any) => {
          this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
        }
      });
    } else {
      if (this.last_organization_id != this.contact.organization_id) {
        this.confirmMoveData();
      } else {
        this.contactService.save(this.contact.id, this.contact).subscribe({
          next: (data: any) => {
            if (this.contact.disabled == true) {
              this.alertDisable();
            } else {
              this.messageService.add({
                closable: false, severity: "success", detail: this.translateService.instant("component.contacts.detail.save_contact_correct")
              });
              //this.dynamicDialogRef.close(data);
              if (this.previousUrl != null && this.previousUrl != "") {
                this.router.navigate([this.previousUrl]);
              } else {
                this._location.back();
              }
            }
          },
          error: (error: any) => {
            this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
          }
        });
      }
    }
  }

  confirmMoveData() {
    this.coreDialogService.confirm({
      message: this.translateService.instant("component.contacts.detail.confirm_move_data"),
      header: this.translateService.instant("general.confirmation_delete_title"),
      icon: "pi pi-info-circle",
      accept: () => {
        this.contactService.changeOrganizationAndSave(this.contact.id, this.contact, true).subscribe({
          next: (data: any) => {
            this.messageService.add({ closable: false, severity: "success", detail: this.translateService.instant("component.contacts.detail.save_contact_correct") });
            //this.dynamicDialogRef.close(data);
            this._location.back();
          },
          error: (error: any) => {
            this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
          }
        });
      },
      reject: () => {
        this.contactService.changeOrganizationAndSave(this.contact.id, this.contact).subscribe({
          next: (data: any) => {
            this.messageService.add({ closable: false, severity: "success", detail: this.translateService.instant("component.contacts.detail.add_contact_correct") });
            this._location.back();
          },
          error: (error: any) => {
            this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
          }
        });
      }
    })
  }

  delete() {
    this.coreDialogService.confirm({
      message: this.translateService.instant("component.organizations.delete_message", { name: this.contact.name }),
      header: this.translateService.instant("general.confirmation_delete_title"), // this.translateService.instant("general.confirmation_delete_title"),
      icon: "pi pi-info-circle",
      accept: () => {
        this.contactService.delete(this.contact.id).subscribe({
          next: (data: any) => {
            this.messageService.add({ closable: false, severity: 'success', detail: this.translateService.instant("general.confirmation_delete") });
            //this.dynamicDialogRef.close();
            //this._location.back();
            if (this.previousUrl != null && this.previousUrl != "") {
              this.router.navigate([this.previousUrl]);
            } else {
              this.router.navigate(['/contacts']);
            }
          },
          error: (error: any) => {
            this.messageService.add({ closable: false, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: () => {

      }
    })
  }
  newMail(emailAcc) {
    const ref = this.dialogService.open(MailingDetailComponent, {
      data: {
        to: emailAcc,
        entity_id: 2,
        entity_pk_id: this.contact.id,
        organization_id: this.contact.organization_id,
        contact_id: this.contact.id,
        //template_type_id: 1,
        template_type_code: "MAIL",
        searchRelated: true
      },
      header: this.translateService.instant("general.new_mail_title"),//"Nuevo mensaje de correo",
      width: '70%',
    });
    ref.onClose.subscribe((data: any) => {
      if (data) {
        //this.dynamicDialogRef.close(data);
        location.reload();
      }
      if (typeof (this.view) !== "undefined") this.viewsService.changeView(this.view.code);
    });
  }

  isDuplied(contact, event) {
    if (!event.valid) {
      this.messageService.add({ closable: false, severity: "error", detail: this.translateService.instant("general.form_incomplete") });
      return;
    }
    this.contactService.isDuplied(contact).subscribe(
      data => {
        if (data == true) {
          this.coreDialogService.notify({
            message: this.translateService.instant("component.contacts.detail.contact_duplicate"), //"Ya existe un contacto con estos datos proporcionados.",
            header: this.translateService.instant("general.error"),
            icon: 'far, exclamation-circle',
            color: 'var(--orange-500)',
            accept: () => { }
          });
        } else {
          this.save(event);
        }
      }
    );
  }

  refreshAll() {
    this.view.view?.configuration?.components?.array?.forEach(component => {
      this.view.fireEvent(component.code, "reload");
    });
    this.view.fireEvent("contacts.campaigns", "reload");
  }


  openNotificationStats() {
    const ref = this.dialogService.open(MailMarketingNotificationToStatsComponent, {
      data: {
        //organization_id: this.contact.organization_id,
        contact_id: this.contact.id,
      },
      header: this.translateService.instant("component.contacts.detail.report_clicks"),
      width: '70%'
    });
    ref.onClose.subscribe((data: any) => {
      //nothing
    })
  }

  openCall(tlfn: string): void {
    // Verificar si el navegador soporta la función de llamada telefónica
    if ('open' in window) {
      // Utilizar el protocolo tel: seguido del número de teléfono
      window.open(`tel:${tlfn}`);
    } else {
      // Manejar el caso donde la función de llamada telefónica no está soportada
      console.log('Tu navegador no soporta la función de llamada telefónica.');
    }
  }


  validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  openEmails() {
    if (this.contact.id != null) this.router.navigate(["/emails", (this.organization.id ? this.organization.id : 0), this.contact.id]);
  }

  alertDisable() {
    this.coreDialogService.notify({
      message: this.translateService.instant("component.contacts.detail.disabled_contact_alert"),//"Se ha dado de baja el contacto.",
      header: this.translateService.instant("general.error"),
      icon: 'far exclamation-circle',
      color: 'var(--orange-500)',
      accept: () => {
        this.messageService.add({ closable: false, severity: "success", detail: this.translateService.instant("component.contacts.detail.save_contact_correct") });
        this._location.back();
      }
    });
  }
  unlinkCampaign(campaign) {
    this.coreDialogService.confirm({
      message: this.translateService.instant("component.contacts.unlink_campaign", { name: campaign.name }),
      header: this.translateService.instant("general.confirmation_delete_title"),
      icon: "pi pi-info-circle",
      accept: () => {
        this.campaignContactsService.unlinkContact({ contact_id: this.contact.id, campaign_id: campaign.id }).subscribe({
          next: (data: any) => {
            this.messageService.add({ closable: false, severity: 'success', detail: this.translateService.instant("general.confirmation_delete") });
            this.refreshAll();
            //this.dynamicDialogRef.close();
          },
          error: (error: any) => {
            this.messageService.add({ closable: false, severity: 'error', detail: error.error.title });
          }
        })
      },
      reject: () => {

      }
    });
  }
  openCampaign(campaign) {
    window.open("/campaigns/" + (campaign.id ? campaign.id : 0));
  }

  addCampaigns() {
    const ref = this.dialogService.open(AddCampaignsToEntityComponent, {
      data: {
        id: this.contact.id,
        entity: 'contact'
      },
      header: this.translateService.instant("component.campaigns.addCampaigns"),
      width: '70%'
    });
    ref.onClose.subscribe((data: any) => {
      this.refreshAll();
    });
  };
  navigateToListFilteredByOrganization() {
    this.router.navigate(['/contacts/', "organization", this.contact.organization_id]);
  }
  setMarker() {
    /*if(this.organization.lat == 0 || this.organization.lng == 0){
      this.messageService.add({ closable: false, severity: "error", detail: "No se pudo identificar la ubicación en el mapa. Las coordenadas 'latitud' o 'longitud' no son correctas o la dirección está mal escrita." });
      return;
    }*/
    if (!this.view_map_button) return;
    const ref = this.dialogService.open(MapsDetailComponent, {
      data: {
        lat: this.contact.lat,
        lng: this.contact.lng,
        contact: this.contact,
        organization: this.contact
      },
      header: "Mapa",
      width: '50%',
    });
    ref.onClose.subscribe((data: any) => {
      if (typeof (this.view) !== "undefined") this.viewsService.changeView(this.view.code);
      if (data) {
        this.organization = data;
        this.contactService.save(this.contact.id, this.contact).subscribe({
          next: (data: any) => {
            this.messageService.add({ closable: false, severity: "success", detail: this.translateService.instant("component.organizations.position_map_updated") });
          },
          error: (error: any) => { }
        });
      }
    })
  }

  openRRSS(event: any) {
    if (event.entityField.name == "twitter") {
      if (this.contact.twitter.startsWith("http://") || this.contact.twitter.startsWith("https://")) {
        window.open(this.contact.twitter, "_blank");
      } else {
        if (this.contact.twitter.startsWith("@")) {
          this.contact.twitter = this.contact.twitter.substring(1);
        }
        window.open("https://x.com/" + this.contact.twitter, "_blank");
        //window.open("https://twitter.com/" + this.contact.twitter, "_blank");
      }
    }
    if (event.entityField.name == "linkedin") {
      window.open("https://www.linkedin.com/in/" + this.contact.linkedin, "_blank");
    }
    if (event.entityField.name == "facebook") {
      if (this.contact.facebook.startsWith("http://") || this.contact.facebook.startsWith("https://")) {
        window.open(this.contact.facebook, "_blank");
      } else {
        window.open("https://www.facebook.com/" + this.contact.facebook, "_blank");
      }
    }
    if (event.entityField.name == "instagram") {
      if (this.contact.instagram.startsWith("http://") || this.contact.instagram.startsWith("https://")) {
        window.open(this.contact.instagram, "_blank");
      } else {
        window.open("https://www.instagram.com/" + this.contact.instagram, "_blank");
      }
    }
    if (event.entityField.name == "tiktok") {
      if (this.contact.tiktok.startsWith("http://") || this.contact.tiktok.startsWith("https://")) {
        window.open(this.contact.tiktok, "_blank");
      } else {
        window.open("https://www.tiktok.com/@" + this.contact.tiktok, "_blank");
      }
    }
    if (event.entityField.name == "youtube") {
      if (this.contact.youtube.startsWith("http://") || this.contact.youtube.startsWith("https://")) {
        window.open(this.contact.youtube, "_blank");
      } else {
        window.open("https://www.youtube.com/" + this.contact.youtube, "_blank");
      }
    }
    if (event.entityField.name == "pinterest") {
      if (this.contact.pinterest.startsWith("http://") || this.contact.pinterest.startsWith("https://")) {
        window.open(this.contact.pinterest, "_blank");
      } else {
        window.open("https://www.pinterest.com/" + this.contact.pinterest, "_blank");
      }
    }
  }

  reorderPositions(dragIndex, dropIndex, dragItem, dropItem) {
    dragItem.position = dragIndex;
    dropItem.position = dropIndex;
  }
  viewTask(task) {
    this.openTask(task, null, null);
  }

  openTask(task, prev, next) {
    var params2: any = {};
    var params = {
      _sortBy: "task_action_scheduled_date",
      _sortDirection: "asc"
    };
    params = Object.assign(params, this.tasksFilters);
    if (params != null) {
      Object.keys(params).forEach(key => {
        if (typeof (params[key]) != "undefined" && params[key] != null) params2[key] = params[key];
      });
    }

    params2['organization_id'] = this.organization.id;
    params2['contact_id'] = this.contact.id;
    // Convierte el objeto params a una cadena JSON
    var paramsString = JSON.stringify(params2);

    // Guarda la cadena JSON en el localStorage con la clave "contact.tasks"
    localStorage.setItem("contact.tasks", paramsString);
    localStorage.removeItem("tasks.list");
    localStorage.removeItem("home.tasks");
    console.log("asdf params tasks contact", paramsString);

    this.router.navigate(['/tasks/', this.contact.organization_id, (task?.id ? task.id : 0)]);
  }
  loadPrevOrNext(id: number) {
    let table: ViewComponentTableComponent = this.view.getComponent("contacts.tasks");
    let prev: any = null;
    let next: any = null;
    let task: any = null;
    for (let i = 0; i < table.rows.length; i++) {
      if (table.rows[i].id == id) {
        task = table.rows[i];
        if ((i + 1) <= (table.rows.length - 1)) next = table.rows[i + 1];
        break;
      }
      prev = table.rows[i];
    }
    if (task != null) this.openTask(task, prev, next);
  }
  deleteTask(task) {
    this.coreDialogService.confirm({
      message: this.translateService.instant("component.organizations.delete_message_task", { subject: task.subject }),
      header: this.translateService.instant("general.confirmation_delete_title"),
      icon: "pi pi-info-circle",
      accept: () => {
        this.tasksService.delete(task.id).subscribe(
          data => {
            this.messageService.add({ closable: false, severity: 'success', detail: this.translateService.instant("general.confirmation_delete") });
            this.view.fireEvent("contacts.tasks", "reload");
          },
          error => {
            this.messageService.add({ closable: false, severity: 'error', detail: error.error.title });
          }
        )
      },
      reject: () => {

      }
    })
  }

  seeFinalizedTasks(seeFinalizedTasks) {
    if (seeFinalizedTasks) {
      this.contact.is_finished = true;
    } else {
      this.contact.is_finished = false;
    }
    this.view.fireEvent("contacts.tasks", "reload");
  }

  viewTransaction(event, data, transaction_type_id, code) {
    this.router.navigate(['/transactions/', transaction_type_id, (this.contact.id ? this.contact.id : 0), (this.contact.organization_id ? this.contact.organization_id : 0), (data?.id ? data.id : 0)]);
  }

  deleteTransaction(transaction) {
    var code = transaction.transactionType.code;
    this.coreDialogService.confirm({
      //TODO: Necesita traducción:
      message: "¿Quieres borrar la transacción?",
      header: this.translateService.instant("general.confirmation_delete_title"),
      icon: "pi pi-info-circle",
      accept: () => {
        this.transactionsService.delete(transaction.id).subscribe({
          next: (data: any) => {
            this.messageService.add({ closable: false, severity: 'success', detail: this.translateService.instant("general.confirmation_delete") });
            this.view.fireEvent("contacts.oportunities", "reload");
            this.view.fireEvent("contacts.sales", "reload");
            this.view.fireEvent(code, "reload");
          },
          error: (error: any) => {
            this.messageService.add({ closable: false, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: () => {
      }
    });
  }

  viewMeeting(meeting) {
    var params = {
      id: meeting ? meeting.organization_id : this.contact.organization_id,
      contactId: meeting ? meeting.contact_id : this.contact.id,
      meetingId: meeting ? meeting.id : 0,
      deactivated: meeting ? true : false
    }
    // Utiliza router.navigate y pasa el objeto de parámetros
    this.router.navigate(['/meetings/', (meeting ? meeting.id : 0)], { queryParams: params });
  }

  deleteMeeting(meeting) {
    this.coreDialogService.confirm({
      message: this.translateService.instant("component.tasks.detail.delete_message_meeting", { subject: meeting.subject }),
      header: this.translateService.instant("general.confirmation_delete_title"),
      icon: "pi pi-info-circle",
      accept: () => {
        this.meetingsService.delete(meeting.id).subscribe({
          next: (data: any) => {
            this.messageService.add({ closable: false, severity: 'success', detail: this.translateService.instant("general.confirmation_delete") });
            this.view.fireEvent("contacts.meetings", "reload");
          },
          error: (error: any) => {
            this.messageService.add({ closable: false, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: () => {

      }
    })
  }

  goToCalendar() {
    if (this.dialogRef) {
      this.dialogRef.close();
    }

    this.router.navigate(['/calendar']);
  }

  onEvent(event: any) {
    if (event.event == "refreshAll" && event.action.name == "refreshAll") this.loadData(this.contact.id);
    if (event.component == "contacts.detail") {
      if (event.event == "action" && event.action.name == "openNotificationStats") this.openNotificationStats();
      if (event.event == "action" && event.action.name == "delete") this.delete();
      if (event.event == "action" && event.action.name == "cancel") this.cancel();
      if (event.event == "action" && event.action.name == "save") this.isDuplied(this.contact, event);
      if (event.event == "fieldAction" && event.action.name == "new-mail") this.newMail(event.value);
      if (event.event == "action" && event.action.name == "openNotificationsStats") this.openNotificationStats();
      if (event.event == "action" && event.action.name == "openEmails") this.openEmails();
      if (event.event == "fieldAction" && event.action.name == "openCall") this.openCall(event.value);
      if (event.event == "fieldAction" && event.action.name == "set-marker") {
        this.setMarker();
      }
      if (event.event == "fieldAction" && event.action.name == "openRRSS") {
        this.openRRSS(event);
      }
    }
    else if (event.component == "contacts.tasks") {
      console.log("asdf event tasks", event);
      if (event.event == "reorder") this.reorderPositions(event.data.dragIndex, event.data.dropIndex, event.dragItem, event.dropItem);
      if (event.event == "dblclick") this.loadPrevOrNext(event.data.id);
      if (event.event == "action" && event.action.name == "add") this.viewTask(null);
      if (event.event == "action" && event.action.name == "edit") this.loadPrevOrNext(event.data.id);
      if (event.event == "action" && event.action.name == "delete") this.deleteTask(event.data);
      if (event.event == "action" && event.action.name == "seeFinalizedTasks") this.seeFinalizedTasks(true);
      if (event.event == "action" && event.action.name == "hideFinalizedTasks") this.seeFinalizedTasks(false);
    }
    else if (event.component == "contacts.meetings") {
      if (event.event == "action" && event.action.name == "add") this.viewMeeting(null);
      if (event.event == "action" && event.action.name == "edit") this.viewMeeting(event.data);
      if (event.event == "action" && event.action.name == "delete") this.deleteMeeting(event.data);
      if (event.event == "dblclick") this.viewMeeting(event.data);
      if (event.event == "action" && event.action.name == "calendar") this.goToCalendar();
    }
    else if (event.component == "contacts.oportunities") {
      if (event.event == "action" && event.action.name == "add") this.viewTransaction(event, null, 1, "oportunidad");
      if (event.event == "action" && event.action.name == "edit") this.viewTransaction(event, event.data, 1, "oportunidad");
      if (event.event == "action" && event.action.name == "delete") this.deleteTransaction(event.data);
      if (event.event == "dblclick") this.viewTransaction(event, event.data, 1, "oportunidad");
    } else if (event.component == "contacts.sales") {
      if (event.event == "action" && event.action.name == "add") this.viewTransaction(event, null, 2, "venta");
      if (event.event == "action" && event.action.name == "edit") this.viewTransaction(event, event.data, 2, "venta");
      if (event.event == "action" && event.action.name == "delete") this.deleteTransaction(event.data);
      if (event.event == "dblclick") this.viewTransaction(event, event.data, 2, "venta");
    }
    else if (event.component == "contacts.campaigns") {
      if (event.event == "action" && event.action.name == "add") this.addCampaigns();
      if (event.event == "action" && event.action.name == "edit") this.openCampaign(event.data);
      if (event.event == "action" && event.action.name == "unlink") this.unlinkCampaign(event.data);
    }
    if (event.component == "view" && event.event == "entity-loaded") {
      //this.config.header = typeof (this.contact.id) !== "undefined" ? "Detalles del " + this.view.getEntityBaseName() : "Nuevo " + this.view.getEntityBaseName();
    }
  }
}
